import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

// Store
import { actions } from 'core/store'

// Styled Components
import { Wrapper } from './VaspDetails.elements'

// Views
import { Container } from 'views/components'
import { App, Header, Sidebar, Content, PageWrapper } from 'views/layouts'
import { VaspDetails as VaspDetailsWrapper } from 'views/containers'

// Map Redux Props
const mapStateToProps = (state) => state
const mapDispatchToProps = actions

function VaspDetails() {
  return (
    <App>
      <Sidebar />
      <Header link="/directory/vasps" pageTitle="Vasps" />
      <Content>
        <PageWrapper>
          <Container>
            <Wrapper>
              <VaspDetailsWrapper />
            </Wrapper>
          </Container>
        </PageWrapper>
      </Content>
    </App>
  )
}

// Default Props
VaspDetails.defaultProps = {
  actions: {},
  ui: {},
  filters: {},
}

// Proptypes Validation
VaspDetails.propTypes = {
  actions: PropTypes.shape({
    setActiveModule: PropTypes.func,
    setShowHeaderLoader: PropTypes.func,
  }),
  ui: PropTypes.shape({}),
  filters: PropTypes.shape({}),
}

export default connect(mapStateToProps, mapDispatchToProps)(VaspDetails)
